// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"643": "3996509e","731": "3bc8b0ac","95": "f3c9698e",}[chunkId] + ".css"
}